"use client";

import { useState, useEffect } from "react";
import { useAuth } from "@/contexts/auth-context";
import { useRouter } from "next/navigation";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";
import { Eye, EyeOff } from "lucide-react";
import Link from "next/link";
import { LoginSignupShared } from "./login-signup-shared";
import { API_BASE_URL } from "@/config";
export function LoginForm() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const {
    login
  } = useAuth();
  const router = useRouter();
  const [isView, setIsView] = useState(false);
  useEffect(() => {
    // Use router.push for client-side navigation instead of window.location
    const redirectUrl = `${API_BASE_URL.replace(/\/cns\/v1$/, '')}/oauth2/authorization/okta`;
    router.push(redirectUrl);
  }, [router]);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);
    try {
      const success = await login(username, password);
      if (success) {
        // Note: Actual redirect will be handled by the login page useEffect
        // which checks user.enabled for proper routing
      } else {
        setError("Invalid username or password");
      }
    } catch (err) {
      setError("An error occurred during login. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };
  return <div className="flex flex-col items-center justify-center min-h-screen">
            <div className="text-lg text-muted-foreground">Redirecting to login...</div>
            <div className="mt-4 animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary" />
        </div>;
}